import { useState, useEffect } from 'react';

// The body has a DPI-compensation scale transform (see App.js) which makes
// body the containing block for position: fixed. As a result, the usual
// "bottom: 0" anchors the footer at body's scaled bottom (not viewport bottom).
// Instead we read window.innerHeight directly (which is always the real visible
// viewport height) and compute the CSS top so the rendered footer bottom lands
// exactly at the viewport bottom on any DPI/scaling.
const Footer = () => {
  const [topPx, setTopPx] = useState(0);

  useEffect(() => {
    const calc = () => {
      // Mirror what App.js does for DPI compensation: at ratio > 1, the body
      // gets transform: scale(1/ratio). Compute scaleY directly from
      // devicePixelRatio so we don't depend on getComputedStyle(body).transform
      // being set yet - App.js's useEffect may run AFTER ours on mount.
      // On macOS, App.js skips the body transform entirely, so scaleY must
      // stay at 1 regardless of devicePixelRatio.
      const isMac = /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent);
      const ratio = window.devicePixelRatio || 1;
      const scaleY = !isMac && ratio > 1 ? 1 / ratio : 1;
      const vh = window.innerHeight;
      const footerHeight = 22;
      // To render footer's bottom at viewport bottom:
      // (top + height) * scaleY = vh  =>  top = vh/scaleY - height
      setTopPx((vh / scaleY) - footerHeight);
    };
    calc();
    window.addEventListener('resize', calc);
    return () => window.removeEventListener('resize', calc);
  }, []);

  return (
    <footer
      style={{
        position: 'fixed',
        top: `${topPx}px`,
        left: 0,
        right: 0,
        textAlign: 'center',
        padding: '4px 0',
        fontSize: '11px',
        color: '#888',
        background: 'rgba(255,255,255,0.85)',
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      powered by 6297803 Canada Inc, @2026
    </footer>
  );
};

export default Footer;
